import { styled } from 'goober';

import { Greetings } from '@/components/greetings/greetings';
import { ActiveProjectWidget } from '@/features/home/dashboard/active-projects-widget/active-projects-widget';
import { CompaniesInProjectCharts } from '@/features/home/dashboard/companies-in-project-charts/companies-in-project-charts';
import { CompaniesStatsWidget } from '@/features/home/dashboard/companies-stats/companies-stats-widget';
import { ExploreAiLinkWidget } from '@/features/home/dashboard/explore-ai-link-widget/explore-ai-link-widget';
import { RecentItemsWidget } from '@/features/home/dashboard/recent-items/recent-items-widget';
import { NotificationsSidebar } from '@/features/notifications/notifications-sidebar';
import { Inline, Stack } from '@/ui/line/line';
import { FullSizedHeader } from '@/ui/typography/across-platform';

export const Dashboard = () => {
  return (
    <>
      <Container>
        <FullSizedHeader data-testid="greetings-header">
          <Greetings />
        </FullSizedHeader>
        <Stack maxWidth="1270px" margin="0px auto 50px auto" gap="24px">
          <RecentItemsWidget />
          <ExploreAiLinkWidget />
          <CompaniesInProjectCharts />
          <StatsContainer gap="24px" alignItems="stretch">
            <ActiveProjectWidget />
            <CompaniesStatsWidget />
          </StatsContainer>
        </Stack>
      </Container>
      <NotificationsSidebar />
    </>
  );
};

const Container = styled('div')`
  max-width: 1375px;
  padding: 0 70px;
  margin: 0 auto;
`;

const StatsContainer = styled(Inline)`
  height: 576px;
`;
